export default __webpack_public_path__ + "static/media/banner-avt.9083d854.png";